<template>
  <section>
    <figure class="w-100 d-flex justify-content-center mb-5">
      <img src="/img/site/_loading.gif" alt="" />
    </figure>
    <div class="d-flex flex-column justify-content-center content-center mt-1">
      <h3 class="mb-3">
        {{ $t('manageplan.component.modal.loading-payment.title') }}
      </h3>
      <p class="px-5 mx-4 text-gray-500">
        {{ $t('manageplan.component.modal.loading-payment.description') }}
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ModalLoadingPayment',
}
</script>

<style lang="scss"></style>
